import { useEffect, useRef } from 'react';
import { useNavigation, Form, useActionData } from 'react-router-dom';
import Field from '../components/form/Field.jsx'
import Button from '../components/Button.jsx'
import ReactRecaptcha3 from 'react-google-recaptcha3'
import { RequestPasswordRecoveryAccount } from '../repo/AccountsRepo.js';
import { config } from '../config';

export default function AccountPasswordRequestRecovery({request}) {
  const emailRef = useRef("")
  const responseData = useActionData()
  const passwordRecoveryNavigation = useNavigation()
  const isSubmitting = passwordRecoveryNavigation.state === 'submitting'

  useEffect(() => {
    ReactRecaptcha3.init(config.recaptchaPublicKey).then(status => {
      if (status !== 'success') {
        console.log("Error! Could not load Recaptcha.")
      }
    })
  }, [])

  function successResponse(respData) {
    return (respData && respData.success)
  }

  return (
    <section>
      {!successResponse(responseData) && (
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <h1 className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
          Recuperar Senha
        </h1>

        <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <Form method="POST" className="space-y-4 md:space-y-6">
              <div className="flex items-center p-4 mb-4 text-sm text-blue-800 border border-blue-300 rounded-lg bg-blue-50" role="alert">
                <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                </svg>
                <span className="sr-only">Info</span>
                <div>
                  Para recupar sua senha, por favor, nos informe seu email. Em seguida você receberá a instrução de como proceder.
                </div>
              </div>

              <Field type={"email"} name={"email"} id={"email"} label={"Email"} required={""} ref={emailRef}/>

              <Button styleName="green" className="w-full" disabled={isSubmitting}>
                {isSubmitting ? 'Solicitando...' : 'Solicitar recuperação de senha'}
              </Button>
            </Form>
          </div>
        </div>
      </div>)}

      {successResponse(responseData) && (
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0 w-full lg:w-1/2">
        <h1 className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
          Recuperar Senha
        </h1>

        <div className="flex items-center mt-8 p-4 mb-4 text-sm text-green-800 border border-green-300 rounded-lg bg-green-50 w-full" role="alert">
          <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
          </svg>
          <span className="sr-only">Info</span>
          <div>
            Um email foi enviado para <b>{emailRef.current.value}</b> com as instruções de como recupar a senha.
          </div>
        </div>
      </div>)}
    </section>
  )
}

async function getRecaptchaToken() {
  let recaptchaToken = '';

  await ReactRecaptcha3.getToken().then(token => {
    recaptchaToken = token
  }, error => {
    console.log("ERROR!", error)
  })

  return recaptchaToken;
}

export async function action({request}) {
  const data = await request.formData()
  const recaptchaToken = await getRecaptchaToken()

  return await RequestPasswordRecoveryAccount(data.get('email'), recaptchaToken)
}
